import { useContext, useState } from 'react';
import Axios from 'axios';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Button, Col, Modal, Row } from 'antd';
import Switchrs from 'components/inputs/Switchrs';

const SendingMessage = ({ openModal, close, id, isCustomer = false }) => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);

  const [formData, setFormData] = useState({});
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const submit = async () => {
    if (!formData?.notification) {
      return toaster.error('لطفا پیام را وارد کنید.');
    }

    setSubmitLoading(true);

    try {
      let url = isCustomer
        ? '/customerMessage/create'
        : '/workerMessage/create';

      const response = await Axios.post(
        urldashboard + url,
        JSON.stringify(
          isCustomer
            ? { ...formData, userId: id }
            : { ...formData, workerIds: [id] },
        ),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        },
      );
      toaster.success(response?.data?.message);
      setSubmitLoading(false);
      close();
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  return (
    <Modal
      title={'ارسال پیام'}
      width={750}
      open={openModal}
      onCancel={close}
      closable={false}
      footer={[
        <Button
          block
          key='submit'
          loading={submitLoading}
          onClick={() => submit()}
          className='btn btn-primary rounded-0'
        >
          ثبت
        </Button>,
      ]}
    >
      <Row gutter={20} align={'middle'}>
        <Col span={24}>
          <div className='form-group'>
            <label htmlFor='notification'>متن پیام</label>
            <textarea
              className='form-control'
              id='notification'
              rows='6'
              onChange={(e) => handleChange('notification', e.target.value)}
            ></textarea>
          </div>
        </Col>
        <Col span={12}>
          <Switchrs
            label='آیا پیامک ارسال شود؟'
            name='hasSend'
            handelValue={(_, value) => handleChange('hasSend', value)}
          />
        </Col>
        <Col span={12}>
          <Switchrs
            label='آیا به اپلیکیشن ارسال شود؟'
            name='hasApplication'
            handelValue={(_, value) => handleChange('hasApplication', value)}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default SendingMessage;
